<div class="dialog">
  <div class="dialog__header">
    <mat-icon (click)="close()" class="close-icon remove">close</mat-icon>
  </div>

  <div class="dialog__body">
    <coa-add-to-group
      (showCreateGroup)="showAddToGroup = false"
      *ngIf="showAddToGroup"
      [clientId]="clientId"
      [selections]="selections"
      class="add-to-group">
    </coa-add-to-group>

    <coa-create-group
      (showAddToGroup)="showAddToGroup = true"
      *ngIf="!showAddToGroup"
      [clientId]="clientId"
      [selections]="selections"
      class="create-group">
    </coa-create-group>
  </div>
</div>


